import { getSavedAudienceSessionSnapshot } from '@/features/audience-interview';
import { ChatTranscriptPreview, type ChatTranscriptMessage } from '@/shared/ui';
import { ArtifactPreviewFallback } from './ArtifactPreviewFallback';
import { ResolveArtifactPreview } from './ResolveArtifactPreview';

interface Props {
  artifactId: string;
}

export function AudienceSessionArtifactPreview({ artifactId }: Props) {
  return (
    <ResolveArtifactPreview
      queryKey="audience-session-artifact-snapshot"
      artifactId={artifactId}
      queryFn={getSavedAudienceSessionSnapshot}
      render={(snapshot) => {
        // Snapshot is validated at the fetch boundary; null means missing/invalid data.
        if (!snapshot) {
          return <ArtifactPreviewFallback />;
        }

        const personaNameById = new Map(snapshot.personas.map((p) => [p.id, p.name]));
        const messages: ChatTranscriptMessage[] = snapshot.messages.map((m) => ({
          role: m.role,
          content: m.content,
          speakerName:
            m.speakerName ?? (m.personaId ? (personaNameById.get(m.personaId) ?? null) : null),
          createdAt: m.createdAt,
          isHandoff: m.isHandoff,
        }));

        return <ChatTranscriptPreview title={snapshot.title} messages={messages} />;
      }}
    />
  );
}
